module.exports = __webpack_public_path__ + "img/color-palette-sample.27824cd0.svg";